import React, { Component } from 'react';
import Modal from './_Modal';
import styled from 'styled-components';
// var { FaMedium, FaGlobe } = require('react-icons/lib/fa');
// import Tooltip from './_Tooltip';
import { withRouter } from 'react-router-dom';

const Wrapper = styled.div`
  text-align: center;
`
const AlignLeft = styled.div`
  text-align: left;
`
const Code = styled.div`
  font-family: monospace;
  border: 1px solid grey;
  border-radius: 3px;
  overflow: scroll;
`
const Span = styled.span`
  margin: 5px;
  ${'' /* margin-left: 150px; */}
`
const Hr = styled.hr`
  margin: 10px 0;
`
const H3 = styled.h3`
  margin-top: 5px;
`

// OUDE DIE OOK SCALE PARAMETERS MEENEEMT:
// const baseString = '<iframe src="https://envelope.li/embed/EV__ID?data=EV__DATAONOFF&scale=EV__SCALEONOFF&scalemobile=EV__SCALEMOBILEONOFF&brand=EV__BRANDONOFF style="width:100%; height:100vh;border:0; overflow:hidden;"> </iframe>'
// NIEUWE:
const baseString = '<iframe src="https://envelope.li/embed/EV__ID?data=EV__DATAONOFF" style="width:EV_WIDTH; height:EV_HEIGHT;border:0; overflow:hidden;"> </iframe>'

class Embed extends Component {
  constructor() {
    super()
    this.state = {
      brand: true,
      data: false,
      scale: false,
      mobile: true,
      width: 700,
      height: 420
    }
  }
  onChange = (str) => {
    var o = this.state[str];
    var newO = {};
    newO[str] = o ? false : true;
    this.setState(newO);
    // console.log('CHECKBOX', e)
  }
  render() {
    // console.log('PROPS', this.props);
    const mapObj = {
      "EV__ID": this.props.match.params.key,
      "EV__DATAONOFF": this.state.data ? 'on' : 'off',
      "EV_WIDTH": this.state.width + 'px',
      "EV_HEIGHT": this.state.height + 'px'
      // "EV__BRANDONOFF": this.state.brand,
      // "EV__SCALEONOFF": this.state.scale,
      // "EV__SCALEMOBILEONOFF": this.state.mobile
    }
    var embedString = baseString.replace(/EV_WIDTH|EV_HEIGHT|EV__ID|EV__DATAONOFF|EV__BRANDONOFF|EV__SCALEONOFF|EV__SCALEMOBILEONOFF/gi, function(matched){
      return mapObj[matched];
    });
    // var embedString = baseString.replace
    return (
      <Wrapper>
        <Modal
          open={this.props.open}
          close={() => this.props.closeModal(this.props.method)}
        >
            <H3>Embed your Envelope</H3>
            <Hr />
            <AlignLeft>
              <input
                checked={this.state.brand}
                type="checkbox"
                onChange={() => this.onChange("brand")}
                disabled={true}
              /><Span>Omit Envelope Brand (Premium)</Span><br/>
              <input
                checked={this.state.data}
                type="checkbox"
                onChange={() => this.onChange("data")}
              /> <Span>Activate data tab</Span> <br />
              <input
                style={{ width: '80px', marginBottom: '3px' }}
                value={this.state.width}
                // placeholder='width[px]'
                onChange={e => this.setState({ width: e.target.value })}
              /><Span>Width[px]</Span><br />
              <input
                style={{ width: '80px' }}
                value={this.state.height}
                // placeholder='height[px]'
                onChange={e => this.setState({ height: e.target.value })}
              /><Span>Height[px]</Span><br />
              {/* <input
                checked={this.state.scale}
                type="checkbox"
                onChange={() => this.onChange("scale")}
              /> Autoscale <br />
              <input
                checked={this.state.mobile}
                type="checkbox"
                onChange={() => this.onChange("mobile")}
              /> Scale for mobile */}
            {/* <Hr />
            <FaMedium /> Embed in an article on Medium
            <FaGlobe /> Embed in Website */}
              <Hr />
              <p>If you don't know which of the above checkboxes to mark, just leave them as they are. </p>
              <Hr />
              <p>Copy the code below in your website. Support for embed in Medium articles and in presentations will follow shortly. Have any other wishes to this embed functionality? Let is know! info@envelope.li.</p>
            <Code>
              {embedString}
            </Code>
          </AlignLeft>
        </Modal>
      </Wrapper>
    )
  }
}

export default withRouter(Embed);



// WEBPACK FOOTER //
// ./src/_EmbedModal.js